// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"db559726","320":"2ad048fe","525":"43957bc0","933":"78619a56"}[chunkId] + ".css";
};